import React from "react";
import { Dialog } from "@vitalsource/vstui";

const InstructorModal = ({ closeModal }) => (
  <Dialog
    open
    key="AutoSharingInstructorModal"
    rootSelector="#bookshelf"
    size="medium"
    onRequestClose={closeModal}
    title={i18n.t(`auto-assign.instructor-handoff-title`)}
    primaryActionButton={{
      label: i18n.t("main-menu.got-it", "Got It"),
      onClick: closeModal
    }}
  >
    <p>{i18n.t(`auto-assign.instructor-handoff-text`)}</p>
  </Dialog>
);

export default InstructorModal;
